<template>
  <!-- Footer -->
  <footer class="footer footer-three">
    <!-- Footer Top -->
    <div class="footer-top aos" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div class="col-lg-2">
            <div class="footer-contact footer-widget">
              <div class="footer-logo">
                <img
                  src="@/assets/img/logo.svg"
                  class="img-fluid aos"
                  alt="logo"
                />
              </div>
              <div class="footer-contact-info">
                <h6>Want to book a bike instantly Contact Us !!!</h6>
                <div class="footer-address">
                  <div class="addr-info">
                    <a href="tel:+1(888)7601940"
                      ><i class="bx bxs-phone"></i>+ 1 (888) 760 1940</a
                    >
                  </div>
                </div>
                <div class="footer-address">
                  <div class="addr-info">
                    <a href="mailto:support@example.com"
                      ><i class="bx bxs-envelope"></i>support@example.com</a
                    >
                  </div>
                </div>
              </div>
              <ul class="store-icon">
                <li>
                  <a href="javascript:void(0);">
                    <img
                      src="@/assets/img/icons/play-icon.svg"
                      class="img-fluid"
                      alt="logo"
                    />
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);">
                    <img
                      src="@/assets/img/icons/app-icon.svg"
                      class="img-fluid"
                      alt="logo"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Company</h5>
              <ul>
                <li>
                  <router-link to="/pages/about-us">Our Company</router-link>
                </li>
                <li>
                  <a href="javascript:void(0)">Bike Rent</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Dreams rent USA</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Dreams rent Worldwide</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Dreams rent Category</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Vehicles Type</h5>
              <ul>
                <li>
                  <a href="javascript:void(0)">Electric</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Scooters</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Sports</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Racing Bikes</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Off-road</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Quick Links</h5>
              <ul>
                <li>
                  <a href="javascript:void(0)">My account</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Campaigns</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Dreams rent Dealers</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Deals and Incentive</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Financial Services</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Resources</h5>
              <ul>
                <li>
                  <a href="javascript:void(0)">Support</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Security</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Help Centers</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Preferences</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Preferences</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h5 class="footer-title">Getting Started</h5>
              <ul>
                <li>
                  <a href="javascript:void(0)">Introduction</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Documentation</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Usage</a>
                </li>
                <li>
                  <a href="javascript:void(0)">API</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Elements</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Footer Top -->

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <!-- Copyright -->
        <div class="copyright">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="copyright-text">
                <p>
                  Copyright © {{ new Date().getFullYear() }} <span>Dreams Rent</span>. All Rights
                  Reserved.
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="footer-list">
                <ul>
                  <li class="country-flag">
                    <div class="dropdown">
                      <a
                        class="dropdown-toggle nav-tog"
                        data-bs-toggle="dropdown"
                        href="javascript:void(0);"
                      >
                        <img src="@/assets/img/flags/us.png" alt="Img" />English
                      </a>
                      <div class="dropdown-menu dropdown-menu-end">
                        <a href="javascript:void(0);" class="dropdown-item">
                          <img src="@/assets/img/flags/fr.png" alt="Img" />French
                        </a>
                        <a href="javascript:void(0);" class="dropdown-item">
                          <img src="@/assets/img/flags/es.png" alt="Img" />Spanish
                        </a>
                        <a href="javascript:void(0);" class="dropdown-item">
                          <img src="@/assets/img/flags/de.png" alt="Img" />German
                        </a>
                      </div>
                    </div>
                  </li>
                  <li class="country-flag lang-nav">
                    <div class="dropdown">
                      <a
                        class="dropdown-toggle nav-tog"
                        data-bs-toggle="dropdown"
                        href="javascript:void(0);"
                      >
                        <i class="bx bx-globe"></i>USD
                      </a>
                      <div class="dropdown-menu dropdown-menu-end">
                        <a href="javascript:void(0);" class="dropdown-item">
                          <img src="@/assets/img/flags/fr.png" alt="Img" />Euro
                        </a>
                        <a href="javascript:void(0);" class="dropdown-item">
                          <img src="@/assets/img/flags/es.png" alt="Img" />INR
                        </a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <ul class="social-icon">
                      <li>
                        <a href="javascript:void(0)"
                          ><i class="fa-brands fa-facebook-f fa-facebook"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0)"
                          ><i class="fab fa-instagram"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0)"
                          ><i class="fab fa-behance"></i
                        ></a>
                      </li>
                      <li>
                        <a href="javascript:void(0)"
                          ><i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)"
                          ><i class="fab fa-linkedin"></i
                        ></a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- /Copyright -->
      </div>
    </div>
    <!-- /Footer Bottom -->
  </footer>
  <!-- /Footer -->
</template>